import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDresser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dresser, drawer"} maskId="square-filled-radius-0-stroke-1-IconDresser"><path fillRule="evenodd" clipRule="evenodd" d="M3 10.5V3H21V10.5H3ZM10 5H14V6H10V5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M3 11.5V19H6V22H7V19H17V22H18V19H21V11.5H3ZM10 13V14H14V13H10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDresser;
